const myThemes = {
  darkblue: {
    palette: {
      primary: "#250E62",
      secondary: "#F2EDFC",
      tertiary: "#E8403C",
      quarternary: "#FFCFBE",
      senary: "#F2EDFC",
    },
  },
  orange: {
    palette: {
      primary: "#FFCFBE",
      secondary: "#250E62",
      tertiary: "#E8403C",
      quarternary: "#250E62",
      senary: "#F2EDFC",
    },
  },
  white: {
    palette: {
      primary: "white",
      secondary: "#2E133A",
      tertiary: "#3E1A4E",
      quarternary: "#2E133A",
      senary: "#AA78F7",
    },
  },
  green: {
    palette: {
      primary: "#white",
      secondary: "#161616",
      tertiary: "#161616",
      quarternary: "#404040",
      senary: "white",
    },
  },
  lightgreen: {
    palette: {
      primary: "#7951A8",
      secondary: "#37AC46",
      tertiary: "#37AC46",
      quarternary: "#37AC46",
      senary: "white",
    },
  },
  purple: {
    palette: {
      primary: "#161616",
      secondary: "#FFFFFF",
      tertiary: "#efefef",
      quarternary: "#d9d9d9",
      senary: "#0d0d0d",
    },
  },
  lightpurple: {
    palette: {
      primary: "#EBE8FC",
      secondary: "#2E133A",
      tertiary: "#EBE8FC",
      quarternary: "#2E133A",
      senary: "#A775F3",
    },
  },
  yellow: {
    palette: {
      primary: "#FFEDC2",
      secondary: "#FFDE90",
      tertiary: "#EBE8FC",
      quarternary: "#2E133A",
      senary: "#A775F3",
    },
  },
  blue: {
    palette: {
      primary: "white",
      secondary: "#007DFE",
      tertiary: "#007DFE",
      quarternary: "#007DFE",
      senary: "white",
    },
  },
  darkblue: {
    palette: {
      primary: "white",
      secondary: "#003087",
      tertiary: "#003087",
      quarternary: "#003087",
      senary: "white",
    },
  },
};

export default myThemes;
